<div 
    *ngIf="showBanner && criticalCount > 0"
    class="relative w-full bg-red-600 dark:bg-red-700 text-white shadow-lg border-b-2 border-red-700 dark:border-red-800 z-40 print:hidden"
    [@slideDown]>
    <div class="flex items-center justify-between px-4 md:px-6 py-3 max-w-screen-2xl mx-auto">
        
        <!-- Left: Icon + Message -->
        <div class="flex items-center gap-3 flex-1 min-w-0">
            <mat-icon class="flex-shrink-0 text-white animate-pulse">warning</mat-icon>
            <div class="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2 min-w-0">
                <span class="font-semibold text-sm sm:text-base">
                    {{ criticalCount }} {{ criticalCount === 1 ? 'alerta nueva' : 'alertas nuevas' }} de alta prioridad
                </span>
                <span class="text-xs sm:text-sm text-red-100 dark:text-red-200 truncate" *ngIf="alertPreview">
                    {{ alertPreview }}
                </span>
            </div>
        </div>

        <!-- Right: Actions -->
        <div class="flex items-center gap-2 flex-shrink-0 ml-4">
            <button 
                mat-flat-button 
                class="!bg-white !text-red-600 hover:!bg-red-50 !shadow-md"
                (click)="reviewAlerts()">
                <mat-icon class="icon-size-5 mr-1">arrow_forward</mat-icon>
                Revisar Ahora
            </button>
            <button 
                mat-icon-button 
                class="!text-white hover:!bg-red-700 dark:hover:!bg-red-800"
                (click)="dismiss()"
                matTooltip="Ocultar por 1 hora">
                <mat-icon class="icon-size-5 !text-white">close</mat-icon>
            </button>
        </div>
    </div>
</div>
